module.exports = __webpack_public_path__ + "img/71.f4a7a015.png";